export default {
  name: "scroll-listener",
  data(){
    return{
      scrollContainer: null,
      scrollContent: null,
      isScrolling: false
    }
  },
  methods:{
    handleScroll(){
      this.isScrolling =  this.scrollContainer.scrollTop > 0;
    },
    handleResize(){
      const containerHeight = this.scrollContainer.getBoundingClientRect().height;
      const contentHeight = this.scrollContent.getBoundingClientRect().height;

      const offset = containerHeight * 0.05;

      if(containerHeight + offset > contentHeight){
        this.scrollContent.style.setProperty('height', (containerHeight + offset) + 'px');
      }
    },
    initScrollListener() {
      let page_scroll = this.$refs['page_scroll']
      if (page_scroll != null) {
        let content = page_scroll.$refs['content']
        if (content != null) {
          this.scrollContainer = content
          this.scrollContent = this.scrollContainer.childNodes[0];

          if(this.scrollContainer) {
            this.scrollContainer.addEventListener('scroll',this.handleScroll);
          }
        }
      }
    }
  },
  beforeUpdate(){
    if(this.scrollContainer == null){
      this.initScrollListener();
    }
  },
  beforeDestroy(){

    if(this.scrollContainer) {
      this.scrollContainer.removeEventListener('scroll',this.handleScroll);
    }

  }
}

